import { useQuery } from "@tanstack/react-query";
import { documentService } from "@/features/documents/services/documentService";
import { queryKeys } from "@/lib/query-keys";
import type { Department } from "@/types/department";
import type { ListDocumentsQuery } from "@/types/document";
import { useGovernanceAllowedDepartments } from "@/hooks/useDepartmentScope";

export function useDocumentScope() {
  return useQuery({
    queryKey: queryKeys.documents.scope(),
    queryFn: () => documentService.getScope(),
  });
}

/** Departments visible in document filters — scoped for Sub-Admins and Editors. */
export function useScopedDocumentDepartments(departments: Department[]) {
  return useGovernanceAllowedDepartments(departments);
}

export function useDocuments(filters?: ListDocumentsQuery) {
  return useQuery({
    queryKey: queryKeys.documents.list(filters),
    queryFn: () => documentService.list(filters),
  });
}

export function useDocument(id: string) {
  return useQuery({
    queryKey: queryKeys.documents.detail(id),
    queryFn: () => documentService.get(id),
    enabled: !!id,
  });
}
